import { FC } from 'react';
import cn from 'classnames';
import parse from 'html-react-parser';

import { BuilderString } from '@/shared/types';
import { IconMap, IconName } from '@/shared/constants/icons';
import {
  getCleanInput,
  isBuilderStringPresent,
  SanitizeMode,
} from '@/shared/text';

import styles from './TopicLead.module.scss';

interface Props {
  number?: BuilderString;
  icon?: IconName;
  locale: string;
}

export const TopicLead: FC<Props> = ({ icon, number, locale }) => {
  if (icon && IconMap[icon]) {
    const Icon = IconMap[icon];
    return <Icon className={cn(styles.icon, 'u-color-secondary')} />;
  }

  if (isBuilderStringPresent(number, locale)) {
    return (
      <div className={cn('u-typography-h1-serif u-color-primary')}>
        {parse(getCleanInput(locale, SanitizeMode.SINGLE_LINE, number))}
      </div>
    );
  }

  return null;
};
